import { InstanceManager, PlanetMediaPlayer } from '../../media-player';
import { ShinyStatPluginOptions } from '../models';
import { VideoAnalyticsTrackerType } from './trackers';
import { VideoAnalyticsPlugin } from './video-analytics-plugin';

export class ShinyStatPlugin extends VideoAnalyticsPlugin {

    static readonly PluginName: string = 'ShinyStatPlugin';

    constructor() {
        super();
    }

    dispose(): void {
        // no-op
    }

    async setup(player: PlanetMediaPlayer, options: ShinyStatPluginOptions): Promise<void> {
        const trackerOptions: ShinyStatPluginOptions = {
            account: options.account,
            category: options.category || '0',
        };
        options.trackers = [{
            type: VideoAnalyticsTrackerType.ShinyStat,
            options: trackerOptions,
        }];
        await super.setup(player, options);
    }

}

/**
 * Register plugin e' necessario perché quando tsc genera il codice javascript
 * si perdono i tipi, non sarebbe quindi possibile istanziare il plugin tramite una
 * factory perché non potremmo mai sapere il nome del costruttore.
 */
InstanceManager.registerPlugin(ShinyStatPlugin.PluginName, ShinyStatPlugin);
